import { ChangeEvent } from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { ClonePipelineType } from './types';
import { Pipeline } from '../../../store/data/types';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { SerializedError } from '@reduxjs/toolkit';
import { useTranslation } from 'react-i18next';

export const defaultCloneFormData = {
  name: '',
  pipeline: '',
};

type Props = {
  pipelines: {
    data: Pipeline[] | undefined;
    error: FetchBaseQueryError | SerializedError | undefined;
    isLoading: boolean;
  };
  data: ClonePipelineType;
  onChange: (data: ClonePipelineType) => void;
};

const ClonePipeline = ({ pipelines: { data: pipelines, isLoading, error }, data, onChange }: Props): JSX.Element => {
  const { t } = useTranslation();

  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange({ ...data, name: event.target.value });
  };

  const handlePipelineChange = (event: SelectChangeEvent) => {
    onChange({ ...data, pipeline: event.target.value });
  };

  return (
    <>
      <TextField variant={'filled'} label={t('Name')} value={data.name} onChange={handleNameChange} fullWidth />
      <FormControl variant={'filled'} fullWidth>
        <InputLabel>Pipeline</InputLabel>
        <Select onChange={handlePipelineChange} value={data.pipeline}>
          {!isLoading &&
            !error &&
            pipelines &&
            pipelines.map((e, i) => (
              <MenuItem key={i} value={e.pid}>
                {e.pipeline.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </>
  );
};

export default ClonePipeline;
